import AddCouncillor from "components/Modal/CouncillorManagement";
import { setSelectedCounsilor } from "pages/Councillors/counsilorSlice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { EditIcon } from "themes/Icon";
import CounsilorProfileUpload from "themes/elements/CounsilorProfileUpload";
import TagComp from "themes/elements/Tag";
import { isPermit } from "utils/permissionCheck";
import style from "./left_section.module.scss";

function LeftSection({ isDetails, fetchCouncillor, setProfile }) {
  const dispatch = useDispatch();
  const [userFileList, setUserFileList] = useState([]);

  const [image, setImage] = useState(isDetails?.user_image || null);

  const [previewImage, setPreviewImage] = useState(image);

  const [editModal, setEditModal] = useState(false);

  useEffect(() => {
    setPreviewImage(isDetails?.councilor_image);
    setImage(isDetails?.councilor_image);
  }, [isDetails]);

  return (
    <div className={style["section-container"]}>
      <div className="flex flex-column gap-6">
        <CounsilorProfileUpload
          setPreviewImage={setPreviewImage}
          fetchCouncillor={fetchCouncillor}
          previewImage={previewImage}
          picture={image}
          fileList={userFileList}
          setFileList={setUserFileList}
          data={isDetails}
        />
        <div className="flex align-center gap-2 wrap">
          <h5 className="page-title overflow-hidden">
            {isDetails?.first_name} {isDetails?.last_name}
          </h5>
          {isDetails?.ward_code && (
            <TagComp className="mr-0">Ward: {isDetails?.ward_code}</TagComp>
          )}{" "}
        </div>
        {isPermit(7, "edit") && (
          <button
            onClick={() => {
              dispatch(setSelectedCounsilor(isDetails));

              setEditModal(true);
            }}
            className={style["edit-btn"]}
          >
            <EditIcon />
          </button>
        )}
      </div>
      <div className="flex flex-column gap-5">
        {isDetails?.term && (
          <div className="flex flex-column gap-1">
            <label className="input-label" htmlFor="">
              Term
            </label>
            <TagComp height={22} color="#E9FBEB" className="councillor-tag">
              Term: {isDetails?.term}
            </TagComp>
          </div>
        )}
        <div className="flex flex-column gap-1">
          <label className="input-label" htmlFor="">
            Email Address
          </label>
          <p className={style["input-value"]}>{isDetails?.email}</p>
        </div>
        <div className="flex flex-column gap-1">
          <label className="input-label" htmlFor="">
            Mobile Number
          </label>
          <p className={style["input-value"]}>{isDetails?.phone_number}</p>
        </div>
      </div>
      <AddCouncillor
        fetchCouncillor={fetchCouncillor}
        data={isDetails}
        isEdit
        open={editModal}
        setOpen={setEditModal}
        setProfile={setProfile}
      />
    </div>
  );
}

export default LeftSection;
